import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {UserProvider} from "./context/UserContext";

// Patch ResizeObserver to prevent the harmless
// "ResizeObserver loop completed with undelivered notifications" error.
// The error occurs when ResizeObserver fires multiple times in a single frame.
// Wrapping the callback in requestAnimationFrame breaks the loop.
// This is the recommended cross-browser fix.
const _RO = window.ResizeObserver;
if (_RO) {
    window.ResizeObserver = class PatchedResizeObserver extends _RO {
        constructor(callback) {
            let scheduled = false;
            super((entries, observer) => {
                if (!scheduled) {
                    scheduled = true;
                    requestAnimationFrame(() => {
                        scheduled = false;
                        callback(entries, observer);
                    });
                }
            });
        }
    };
}

// Fallback: also suppress the error message if it still slips through
window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver loop')) {
        e.preventDefault();
        e.stopImmediatePropagation();
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <UserProvider>
          <App />
      </UserProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
